<template>
  <div style="
          font-family:
          Raleway,
          sans-serif;
          padding-top:
          10px">
    <table justify="center"
      style="width: 100% !important"
      border="1"
      cellspacing="0"
      id="tableTraffic"
      v-if="showTableData && stavke.length > 0">
      <thead>
        <tr :class="['header', 'naslov']"
          style="text-align: center">
          <th colspan="11">Artikli</th>
        </tr>
      </thead>
      <tbody>
        <tr :class="['header', 'naslov']"
          style="font-weight: bold; text-align: left">
          <th colspan="4">Artikl koji je prebačen</th>
          <th colspan="4">Količina</th>
          <th colspan="4">Artikl na koji je prebačeno</th>
        </tr>
        <tr v-for="item in transferData"
          :key="item.id">
          <td colspan="4">{{ item.source_item_name }}</td>
          <td colspan="4">
            {{
              viewType === "pdf"
                ? formatCurrency(item.quantity / 1000, 1)
                : item.quantity / 1000
            }}
          </td>
          <td colspan="4">{{ item.destination_item_name }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>

export default {
  components: {
  },
  inject: ['showMsgBox', 'showLoader', 'hideLoader', 'showAlert'],
  props: {
    transferData: Array,
    stavke: Array,
    showTableData: Boolean,
    viewType: String
  },
  data: () => ({
    currency: 'EUR'
  }),
  async mounted () {
  },
  methods: {
    formatCurrency (item, divider = 100) {
      return this.$options.filters
        .money(item, divider, this.currency)
        .replace('€', '')
    }
  }
}
</script>
<style scoped>
.enabledbutton {
  background-color: #2c97c5 !important;
  border-color: #2c97c5 !important;
  color: white;
  font-weight: 700;
}

.naslov {
  background-color: #d3d3d3;
  border: 1px solid black;
}

.selectedrow-456 {
  background-color: #2c97c5 !important;
  border-color: #2c97c5 !important;
  color: white;
  font-weight: 700;
}

.createDelivery>>>.vm--modal {
  border-radius: 25px !important;
}

.editDelivery>>>.vm--modal {
  border-radius: 25px !important;
}
</style>
